/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NestedNotInPrimitiveString: core.serialization.ObjectSchema<
    serializers.NestedNotInPrimitiveString.Raw,
    Truvity.NestedNotInPrimitiveString
> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace NestedNotInPrimitiveString {
    export interface Raw {
        values: string[];
    }
}
